import { z } from "zod";
import { LetterHeadSchema } from "../../models/letterHead.schema";

export const PrivateLetterheadControllerResponseSchema = {
  listLetterheads: LetterHeadSchema.array(),

  getLetterhead: LetterHeadSchema.nullable(),

  createLetterhead: LetterHeadSchema,

  updateLetterhead: LetterHeadSchema,

  deleteLetterhead: z.void(),
};
